// Merchant landing — pulls /api/merchant/analytics/ and renders headline KPIs
// plus subscription status. No charts (yet) — single fetch keeps it cheap.

import React, { useEffect, useState } from 'react';
import { getAnalytics } from '../../services/merchantService';
import StatCard, { StatRow } from '../common/StatCard';

export default function MerchantDashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    getAnalytics()
      .then(d => { if (alive) setData(d); })
      .catch(e => { if (alive) setError(e?.response?.data?.error || e.message); });
    return () => { alive = false; };
  }, []);

  if (error) return <><div className="portal-content-header"><h1>Dashboard</h1></div><div className="portal-error">{error}</div></>;
  if (!data) return <><div className="portal-content-header"><h1>Dashboard</h1></div><div className="portal-empty">Loading…</div></>;

  const sub = data.subscription;

  return (
    <>
      <div className="portal-content-header">
        <h1>
          {data.store?.name || 'Dashboard'}
          {sub && <span className={`badge badge-${sub.status === 'active' ? 'active' : 'pending'}`}>{sub.tier} · {sub.status}</span>}
        </h1>
      </div>

      {!sub && (
        <div className="portal-card warn">
          <strong style={{ color: 'var(--tudu-text-hi)' }}>No subscription on file.</strong>{' '}
          Contact an admin to activate flyer uploads and unlock the rest of the portal.
        </div>
      )}

      <h3 className="portal-section-label">Coupons</h3>
      <StatRow>
        <StatCard label="Total coupons" value={data.coupons.total} />
        <StatCard label="Active" value={data.coupons.active} />
        <StatCard label="Claims" value={data.coupons.claims_total} hint={`${data.coupons.claims_7d} in last 7d`} />
        <StatCard label="Redeemed" value={data.coupons.redeemed_total} />
      </StatRow>

      <h3 className="portal-section-label">Flyers</h3>
      <StatRow>
        <StatCard label="Total flyers" value={data.flyers.total} />
        <StatCard label="Active" value={data.flyers.active} />
      </StatRow>

      {sub && (
        <>
          <h3 className="portal-section-label">Subscription</h3>
          <div className="portal-card">
            <div className="portal-defs">
              <Def label="Tier" value={sub.tier} />
              <Def label="Status" value={sub.status} />
              <Def label="Commission" value={`${(parseFloat(sub.commission_rate) * 100).toFixed(2)}%`} />
              <Def label="Monthly fee" value={`$${sub.monthly_fee}`} />
              <Def label="Started" value={new Date(sub.started_at).toLocaleDateString()} />
              <Def label="Period end" value={sub.current_period_end ? new Date(sub.current_period_end).toLocaleDateString() : '—'} />
            </div>
            {sub.notes && (
              <div style={{ marginTop: 'var(--tudu-space-4)', padding: 'var(--tudu-space-3)', background: 'var(--tudu-bg-3)', borderRadius: 'var(--tudu-radius-sm)', color: 'var(--tudu-text)' }}>
                <strong style={{ color: 'var(--tudu-text-hi)' }}>Notes:</strong> {sub.notes}
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}

function Def({ label, value }) {
  return (
    <div>
      <div className="portal-def-label">{label}</div>
      <div className="portal-def-value">{value}</div>
    </div>
  );
}
